
import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import "../OrderPage/BusInfo.css";

// Static token as provided


function BusInfo() {
  const [busOrders, setBusOrders] = useState([]);
  const [selectedTab, setSelectedTab] = useState('past');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const accessToken = localStorage.getItem('accessToken') || '';
   const invoiceRef = useRef();

  // Fetch bus orders on component mount
  useEffect(() => {
    fetchBusOrders();
  }, []);

  const fetchBusOrders = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        'https://admintest.jayrajgroup.org/api/bus/book-list',
        {}, // Empty body as per your curl command
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Accept': 'application/json'
          }
        }
      );

      if (response.data && response.data.status && Array.isArray(response.data.data)) {
        // Transform API response to match our component structure
        const transformedOrders = response.data.data.map(order => {
          // Determine status based on booking_status and date
          let status = 'Past';
          const today = new Date();
          const orderDate = new Date(order.created_at);

          // If order date is in the past, mark as Past
          // if (orderDate < today) {
          //   status = 'Past';
          // } else if (order.booking_status) {
          //   status = order.booking_status;
          // }

          return {
            id: order.order_id,
            order_id: order.order_id,
            bus_id: order.bus_id,
            route: `Hyderabad to Bangalore`, // Based on book-details response
            date: formatDateTime(order.created_at),
            pnr: order.pnr,
            ticket_no: order.ticket_no,
            price: `${order.currency || 'INR'} ${order.price || '0.00'}`,
            status: status,
            departureTime: "07:00 AM", // Default, will be updated from details
            arrivalTime: "11:00 AM", // Default, will be updated from details
            busNumber: order.bus_id ? `BUS-${order.bus_id}` : "N/A",
            operator: "TESTING ACCOUNT", // Default, will be updated from details
            boardingPoint: "Chikkadapalli", // Default, will be updated from details
            droppingPoint: "Bangalore", // Default, will be updated from details
            invoice_number: order.invoice_number,
            booking_status: order.booking_status,
            payment_status: order.payment_status,
            // Original API data for reference
            apiData: order
          };
        });

        setBusOrders(transformedOrders);
      } else {
        setBusOrders([]);
      }
    } catch (err) {
      console.error('Error fetching bus orders:', err);
      setError('Failed to load bus orders. Please try again later.');
      // Fallback to mock data if API fails
      setBusOrders(getMockData());
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetails = async (orderId, busId) => {
    try {
      setLoadingDetails(true);

      const response = await axios.post(
        'https://admintest.jayrajgroup.org/api/bus/book-details',
        {
          action: "getBookDetails",
          order_id: orderId,
          BusId: busId
        },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );

      if (response.data && response.data.status && response.data.data.GetBookingDetailResult) {
        const result = response.data.data.GetBookingDetailResult;
        if (result.ResponseStatus === 1 && result.Itinerary) {
          const itinerary = result.Itinerary;

          // Create detailed order object
          const detailedOrder = {
            route: `${itinerary.Origin} to ${itinerary.Destination}`,
            date: formatDate(itinerary.DateOfJourney),
            busType: itinerary.BusType,
            price: `${itinerary.Price?.CurrencyCode || 'INR'} ${itinerary.Price?.PublishedPrice || '0.00'}`,
            status: itinerary.Status === 2 ? 'Confirmed' : 'Pending',
            departureTime: formatTime(itinerary.DepartureTime),
            arrivalTime: formatTime(itinerary.ArrivalTime),
            busNumber: `BUS-${itinerary.BusId}`,
            operator: itinerary.TravelName,
            boardingPoint: itinerary.BoardingPointdetails?.CityPointName || itinerary.Origin,
            droppingPoint: itinerary.Destination,
            journeyDuration: `${itinerary.BlockDuration || 4} hours`,
            bookingDate: formatDateTime(itinerary.InvoiceCreatedOn),
            ticketNumber: itinerary.TicketNo,
            invoiceNumber: itinerary.InvoiceNumber,
            bookingMode: getBookingMode(itinerary.BookingMode),
            serviceName: itinerary.ServiceName,
            passengers: itinerary.Passenger || [],
            cancellationPolicy: itinerary.CancelPolicy || [],
            priceDetails: itinerary.Price || {},
            boardingDetails: itinerary.BoardingPointdetails || {}
          };

          setOrderDetails(detailedOrder);
          return detailedOrder;
        }
      }
      return null;
    } catch (err) {
      console.error('Error fetching order details:', err);
      return null;
    } finally {
      setLoadingDetails(false);
    }
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "Date not specified";

    try {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();

      // Add ordinal suffix
      const getOrdinal = (n) => {
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
          case 1: return "st";
          case 2: return "nd";
          case 3: return "rd";
          default: return "th";
        }
      };

      return `${day}${getOrdinal(day)} ${month} ${year}`;
    } catch (err) {
      return dateString;
    }
  };

  // Helper function to format date and time
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "Not specified";

    try {
      const date = new Date(dateTimeString);
      return date.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (err) {
      return dateTimeString;
    }
  };

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "Not specified";

    try {
      const date = new Date(timeString);
      return date.toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (err) {
      // Try parsing as simple time string
      const match = timeString.match(/(\d{2}):(\d{2})/);
      if (match) {
        const hour = parseInt(match[1]);
        const minute = match[2];
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 || 12;
        return `${formattedHour}:${minute} ${ampm}`;
      }
      return timeString;
    }
  };

  // Helper function to get booking mode
  const getBookingMode = (modeCode) => {
    const modes = {
      1: "Online",
      2: "Offline",
      3: "Mobile",
      4: "Counter",
      5: "Seat Seller"
    };
    return modes[modeCode] || `Mode ${modeCode}`;
  };

  const handleViewDetails = async (order) => {
    setSelectedOrder(order);

    // Fetch additional details from API
    if (order.order_id && order.bus_id) {
      const details = await fetchOrderDetails(order.order_id, order.bus_id);
      if (details) {
        // Update the original order with detailed information
        const updatedOrder = {
          ...order,
          ...details, // Merge all details
          detailedInfo: details
        };
        setSelectedOrder(updatedOrder);
      }
    }

    setShowModal(true);
  };

  const handleCancelOrder = async (orderId) => {
    if (window.confirm("Are you sure you want to cancel this bus order?")) {
      try {
        // Here you would call your cancel API
        // For now, just remove from local state
        setBusOrders(prev => prev.filter(order => order.id !== orderId));

        alert("Order cancelled successfully!");
      } catch (err) {
        console.error('Error cancelling order:', err);
        alert('Failed to cancel order. Please try again.');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
    setOrderDetails(null);
  };

  // Filter orders based on selected tab
  const filteredOrders = busOrders.filter(order => {
    if (selectedTab === 'upcoming') return order.status.toLowerCase() === 'upcoming' || order.status.toLowerCase() === 'confirmed';
    if (selectedTab === 'past') return order.status.toLowerCase() === 'past';
    if (selectedTab === 'bookmarked') return false; // No bookmarked data from API
    return true;
  });

  // Mock data fallback
  const getMockData = () => {
    return [
      {
        id: "696A4BC6D2CFD",
        order_id: "696A4BC6D2CFD",
        bus_id: 37271,
        route: "Hyderabad to Bangalore",
        date: "16th Jan 2026",
        pnr: "2BHT4DP8",
        ticket_no: "2BHT4DP8",
        price: "INR 87.00",
        status: "Past",
        departureTime: "07:00 AM",
        arrivalTime: "11:00 AM",
        busNumber: "BUS-37271",
        operator: "TESTING ACCOUNT",
        boardingPoint: "Chikkadapalli (Pickup Bus)",
        droppingPoint: "Bangalore",
        invoice_number: "MW/2526/21990",
        booking_status: "Confirmed",
        payment_status: "Success"
      }
    ];
  };
  const handleprint = () => {
    const content = invoiceRef.current.innerHTML;
    const win = window.open("", "", "width=800,height=700");

    win.document.write(`
      <html>
        <head>
          <title>Bus Booking Invoice</title>
          <style>
            body { font-family: Arial; padding: 20px; }
            h1, h2 { margin-bottom: 10px; }
            .card { border:1px solid #eee; padding:16px; border-radius:8px; margin-bottom:16px; }
            table { width:100%; border-collapse:collapse; }
            th, td { padding:8px; border-bottom:1px solid #ddd; }
            .right { text-align:right; }
            .status { color: green; font-weight: bold; }
            hr{ margin:20px 0; color:#eee; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <div className="bus-info-container">
      <h2 className="bus-info-title">Bus Orders</h2>

      {/* Loading State */}
      {loading && (
        <div className="loading-state">
          <p>Loading bus orders...</p>
        </div>
      )}

      {/* Error State */}
      {error && !loading && (
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchBusOrders} className="btn-retry">
            Retry
          </button>
        </div>
      )}

      {/* Tab Navigation */}
      <div className="bus-tabs">
        {/* <button 
          className={`bus-tab ${selectedTab === 'upcoming' ? 'active' : ''}`}
          onClick={() => setSelectedTab('upcoming')}
        >
          Upcoming Bus Orders
        </button> */}
        <button
          className={`bus-tab ${selectedTab === 'past' ? 'active' : ''}`}
          onClick={() => setSelectedTab('past')}
        >
          Booked Buses
        </button>
        <button
          className={`bus-tab ${selectedTab === 'bookmarked' ? 'active' : ''}`}
          onClick={() => setSelectedTab('bookmarked')}
        >
          Bookmarked Buses
        </button>
        <button
          className={`bus-tab ${selectedTab === 'reviews' ? 'active' : ''}`}
          onClick={() => setSelectedTab('reviews')}
        >
          Reviews
        </button>
      </div>

      {/* Orders Grid */}
      {!loading && !error && (
        <>
          <div className="bus-orders-grid">
            {filteredOrders.map(order => (
              <div key={order.id} className="bus-order-card">
                {/* <div className="bus-order-header">
                  <h3 className="bus-route">{order.route}</h3>
                  <span className={`bus-status ${order.status.toLowerCase()}`}>
                    {order.status}
                  </span>
                </div> */}

                <div className="bus-order-details">
                  <div className="bus-detail-item">
                    <span className="detail-label">Booking Date:</span>
                    <span className="detail-value">{order.date}</span>
                  </div>
                  <div className="bus-detail-item">
                    <span className="detail-label">Order ID:</span>
                    <span className="detail-value order-id">{order.order_id}</span>
                  </div>
                  <div className="bus-detail-item">
                    <span className="detail-label">PNR:</span>
                    <span className="detail-value pnr">{order.pnr}</span>
                  </div>
                  <div className="bus-detail-item">
                    <span className="detail-label">Ticket No:</span>
                    <span className="detail-value ticket-no">{order.ticket_no}</span>
                  </div>
                  <div className="bus-detail-item">
                    <span className="detail-label">Price:</span>
                    <span className="detail-value price">{order.price}</span>
                  </div>
                </div>

                <div className="bus-order-actions">
                  <button
                    className="btn-view-details"
                    onClick={() => handleViewDetails(order)}
                    disabled={loadingDetails}
                  >
                    {loadingDetails && selectedOrder?.id === order.id ? 'Loading...' : 'View Details'}
                  </button>
                  {(order.status === 'Upcoming' || order.status === 'Confirmed') && (
                    <button
                      className="btn-cancel"
                      onClick={() => handleCancelOrder(order.id)}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredOrders.length === 0 && (
            <div className="no-orders">
              <p>No {selectedTab} bus orders found.</p>
            </div>
          )}
        </>
      )}

      {/* Modal for Order Details */}
      {showModal && selectedOrder && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} >
            <div className="modal-header">
              <h3>Bus Order Details</h3>
              <button className="modal-close" onClick={closeModal}>×</button>
            </div>

            <div className="pdf-ticket" ref={invoiceRef}>
              {loadingDetails ? (
                <div className="loading-details">
                  <p>Loading detailed information...</p>
                </div>
              ) : (
 <div >

  {/* Journey */}
  <section className="pdf-section pdf-journey">
    <h4 className="pdf-title">Journey Information</h4>
    <div className="pdf-grid">
      <div className="pdf-field"><span>Route</span><strong>{selectedOrder.route}</strong></div>
      <div className="pdf-field"><span>Travel Date</span><strong>{selectedOrder.date}</strong></div>
      <div className="pdf-field"><span>Departure</span><strong>{selectedOrder.departureTime}</strong></div>
      <div className="pdf-field"><span>Arrival</span><strong>{selectedOrder.arrivalTime}</strong></div>
      <div className="pdf-field"><span>Duration</span><strong>{selectedOrder.journeyDuration || '4 hours'}</strong></div>
      <div className="pdf-field"><span>Booking Date</span><strong>{selectedOrder.bookingDate || formatDate(selectedOrder.apiData?.created_at)}</strong></div>
    </div>
  </section>

  {/* Booking */}
  <section className="pdf-section pdf-booking">
    <h4 className="pdf-title">Booking Details</h4>
    <div className="pdf-grid">
      <div className="pdf-field highlight"><span>Order ID</span><strong>{selectedOrder.order_id}</strong></div>
      <div className="pdf-field highlight"><span>PNR</span><strong>{selectedOrder.pnr || selectedOrder.apiData?.pnr}</strong></div>
      <div className="pdf-field"><span>Ticket No</span><strong>{selectedOrder.ticketNumber || selectedOrder.ticket_no}</strong></div>
      <div className="pdf-field"><span>Invoice No</span><strong>{selectedOrder.invoiceNumber}</strong></div>
      <div className="pdf-field"><span>Bus No</span><strong>{selectedOrder.busNumber}</strong></div>
      <div className="pdf-field"><span>Operator</span><strong>{selectedOrder.operator}</strong></div>
    </div>
  </section>

  {/* Payment */}
  <section className="pdf-section pdf-payment">
    <h4 className="pdf-title">Payment Information</h4>
    <div className="pdf-grid">
      <div className="pdf-field price"><span>Total Price</span><strong>{selectedOrder.price}</strong></div>
      <div className="pdf-field status"><span>Status</span><strong>{selectedOrder.status}</strong></div>
      <div className="pdf-field"><span>Payment</span><strong>{selectedOrder.payment_status || 'Success'}</strong></div>
      <div className="pdf-field"><span>Booking</span><strong>{selectedOrder.booking_status || 'Confirmed'}</strong></div>
    </div>
  </section>

  {/* Boarding */}
  <section className="pdf-section pdf-location">
    <h4 className="pdf-title">Boarding & Dropping</h4>

    <div className="pdf-location-card">
      <span className="icon up">↑</span>
      <div>
        <strong>Boarding Point</strong>
        <p>{selectedOrder.boardingPoint}</p>
        <small>Arrive 30 min before departure</small>
      </div>
    </div>

    <div className="pdf-location-card">
      <span className="icon down">↓</span>
      <div>
        <strong>Dropping Point</strong>
        <p>{selectedOrder.droppingPoint}</p>
      </div>
    </div>
  </section>

</div>

              )}
            </div>

            <div className="modal-footer">
              <button className="btn-print" onClick={handleprint}>
                Print Ticket
              </button>

              <button className="btn-close" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BusInfo;